<div class="flex-row flex-middle">

  <ng-container
    [ngTemplateOutlet]="controlTemplate"
    [ngTemplateOutletContext]="{ $implicit: outerControl, label: label, isRequired: required() }"
  ></ng-container>

  <sk-button [appearance]="'icon'"
             data-test="open-translations-modal"
             [matTooltip]="'label.Translations' | translate"
             (click)="openTranslationsModal()">
    <i class="icon far fa-globe"></i>
  </sk-button>
</div>

